import { defineStore } from 'pinia';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';

export const useStoreCryptoCountries = defineStore('cryptoCountries', {
  state: () => ({
    countriesList: '',
    requestPromise: null as Promise<any> | null,
  }),

  getters: {
    list(state) {
      return state.countriesList?.replace(/\s+/g, ``).toLowerCase().split(`,`) || [];
    },
  },

  actions: {
    async loadCryptoCountries() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('crypto-countrie')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
